import { V1StripeConnectStatus } from '../subscription_migration';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS = 'V1_STRIPE_CONNECT_STATUS_';

export const V1StripeConnectStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS}${V1StripeConnectStatus.NONE}`]: 'non configuré',
    [`${TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS}${V1StripeConnectStatus.PENDING}`]: 'en attente de validation',
    [`${TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS}${V1StripeConnectStatus.ACTIVE}`]: 'actif',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(
  V1StripeConnectStatus,
  V1StripeConnectStatusTranslation,
  TRANSLATE_KEY_V1_STRIPE_CONNECT_STATUS,
  true,
);
